import React from 'react';
import { handleView } from '../handle_view';
import { applyFilters } from '../../_flux/helper/apply_filters';
import { setSortingAction } from '../../_flux/actions/catalog_sorting_actions';
import * as SortingGoogleAnalytics from '../../_modules/google_analytics/catalog/sorting';
import { sortingToOptionValue } from '../../_modules/sorting/sorting_to_option_value';
import { sortingOptionsToSelectOptions } from '../../_modules/sorting/sorting_options_to_select_options';
import { CatalogSortingStore } from '../../_flux/stores/catalog_sorting_store';
import { CatalogFilters } from '../../_flux/components/catalog_ads/catalog_filters_revamp';
import { FilterValues } from '../../_flux/constants/filter/filter_values';
import { onActionClick, onFilterChange } from '../catalog_filter_column/common';
import CatalogFilterViewStore from '../../_flux/stores/catalog_filter_view_store';
import CatalogTyreFilterStore from '../../_flux/stores/catalog_filter_store/tyre';
import { FilterAvailableOptionsStore } from '../../_flux/stores/filter_available_options_store';
import CatalogConditionalFiltersStore from '../../_flux/stores/catalog_conditional_options_store';
import { getCatalogFilterOptionsStoreByProductType } from '../../_flux/stores/catalog_filter_options_store/factory';
import * as DesktopFiltersGoogleAnalytics from '../../_modules/google_analytics/catalog/desktop_filters';

const stores = {
  catalogSortingState: CatalogSortingStore,
  catalogFilterViewState: CatalogFilterViewStore,
  catalogFilterState: CatalogTyreFilterStore,
  filterAvailableOptionsState: FilterAvailableOptionsStore,
  catalogConditionalFiltersState: CatalogConditionalFiltersStore,
};

const render = (
  {
    catalogSortingState,
    catalogFilterViewState,
    catalogFilterState: filterValues,
    filterOptionsState: filterOptions,
    catalogConditionalFiltersState: conditionalFilters,
  },
  options,
) => {
  const currentSorting = sortingToOptionValue(catalogSortingState.currentSorting);
  const sortingOptions = sortingOptionsToSelectOptions(catalogSortingState.sortingOptions);

  return (
    <CatalogFilters
      sorting={currentSorting}
      sortingOptions={sortingOptions}
      onSortingChange={options.onSortingChange}
      productType={options.productType}
      sectionVisibility={catalogFilterViewState.sectionVisibility}
      conditionalFilters={conditionalFilters}
      filterValues={filterValues}
      filterOptions={filterOptions}
      onToolTipHover={DesktopFiltersGoogleAnalytics.showToolTipAction}
      onChangeCallback={options.onFilterChange}
    />
  );
};

export const init = (container, options) => {
  stores.filterOptionsState = getCatalogFilterOptionsStoreByProductType(options.productType);

  return handleView(stores, render, getOptions(options), container);
};

const getOptions = (options) => ({
  ...options,
  onSortingChange: onSortingChange(options.productType),
  onFilterChange: onFilterChange(options.currencyIsoCode, options.productType),
  onActionClick: onActionClick(options.productType),
});

const onSortingChange = (productType) => (optionValue) => {
  const [sorting, direction] = optionValue.split('::');
  setSortingAction(sorting, direction);
  applyFilters(productType);
  SortingGoogleAnalytics.changeSorting(sorting, direction);
};
